import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import { ClubBadge } from '~/components/Account/Rewards';
import { useLoyaltyPricing } from '~/hooks/useLoyaltyPricing';
import styles from './LoyaltyPriceDisplay.module.css';
type LoyaltyPriceDisplayVariant = 'desktop' | 'mobile' | 'total';
interface LoyaltyPriceDisplayProps {
  readonly variant?: LoyaltyPriceDisplayVariant;
  readonly discountedFormatted?: string;
  readonly originalFormatted?: string;
}
export const LoyaltyPriceDisplay = t0 => {
  const $ = _c(15);
  const {
    variant: t1,
    discountedFormatted,
    originalFormatted
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t = useTranslations("journey");
  const hookPricing = useLoyaltyPricing();
  const isControlled = discountedFormatted !== undefined && originalFormatted !== undefined;
  if (!isControlled && !hookPricing.hasLoyaltyDiscount) {
    return null;
  }
  const showPerPerson = variant !== "total";
  const discounted = isControlled ? discountedFormatted : showPerPerson ? hookPricing.discountedPerPersonFormatted : hookPricing.discountedTotalFormatted;
  const original = isControlled ? originalFormatted : showPerPerson ? hookPricing.originalPerPersonFormatted : hookPricing.originalTotalFormatted;
  const t2 = styles[variant];
  let t3;
  if ($[0] !== t2) {
    t3 = clsx(styles.priceRow, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t("loyalty_benefits_club_badge");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <ClubBadge size="compact">{t4}</ClubBadge>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== discounted) {
    t6 = <span className={styles.discountedPrice}>{discounted}</span>;
    $[6] = discounted;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== original) {
    t7 = <span className={styles.originalPrice}>{original}</span>;
    $[8] = original;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <span className={t3} data-test-id="loyalty-price-display">{t5}{t6}{t7}</span>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};